import { render } from "./Configuracoes.vue?vue&type=template&id=0fd78019&scoped=true"
import script from "./Configuracoes.vue?vue&type=script&lang=js"
export * from "./Configuracoes.vue?vue&type=script&lang=js"

import "./Configuracoes.vue?vue&type=style&index=0&id=0fd78019&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fd78019"]])

export default __exports__